import jsonParse from "web/utils/data/parser/string/jsonParse";

import { ICategory } from "web/types/Category";
import { ICategoryCount } from "web/types/CategoryCount";
import {
  ICategoryFunctionalityMenuItem,
  IFunctionalityMenuItem,
  ISubCategoryMenuItem,
  IUrlFunctionalityMenuItem,
  IUrlMenuItem,
  MenuItemType,
} from "web/types/Menu";

import handleMenuItemWebview from "./handleMenuItemWebview";
import { MenuItemContext, ProcessedMenuItem } from "./types";

const processMenuWebviewData = (
  menuData: string | undefined,
  context: MenuItemContext,
  categoriesData: ICategory[],
  categoriesTree: string[] | undefined,
  categoriesSizes: ICategoryCount[]
): ProcessedMenuItem[] => {
  const parsedMenu = jsonParse<
    (
      | IFunctionalityMenuItem
      | IUrlMenuItem
      | IUrlFunctionalityMenuItem
      | ICategoryFunctionalityMenuItem
      | ISubCategoryMenuItem<MenuItemType.SUBCATEGORIES | MenuItemType.TILES>
    )[]
  >(menuData, true);

  if (!parsedMenu) {
    return [];
  }

  return parsedMenu
    .map((item) =>
      handleMenuItemWebview(
        item,
        context,
        categoriesData,
        categoriesTree,
        categoriesSizes
      )
    )
    .filter((item): item is ProcessedMenuItem => item !== null);
};

export default processMenuWebviewData;
